import isIframe from '../utils/isIframe';
import siteName from '../config';
const THEMES = {
  FleetPartners: '/themes/theme-fleet-partners.css',
  FleetPlus: '/themes/theme-fleet-plus.css',
  FleetSmart: '/themes/theme-fleet-smart.css',
  iframe: '/themes/theme-iframe.css'
};

const addCss = theme => {
  let link = document.createElement('link');
  link.href = theme;
  link.rel = 'stylesheet';
  document.getElementsByTagName('head')[0].appendChild(link);
};

const applyTheme = () => {
  // const [ subdomain, host ] = location.host.split('.');

  // lookup theme or fall back to default theme
  // const themeJS = THEMESJS[host] || THEMESJS.fleetsmart;

  // if iframed, apply common iframed theme
  if (isIframe) {
    console.log('iframed !!', document.referrer);
    // add embed theme override
    addCss(THEMES.iframe);
  } else {
    // otherwise apply site specific theme based on domain
    addCss(THEMES[siteName]);
  }
};

export default applyTheme;



// WEBPACK FOOTER //
// ./src/themes/theme.js